import React from 'react';
import Icon from '../../../components/AppIcon';

const CompanyOverview = ({ company }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 lg:p-8">
      <h2 className="text-2xl font-bold text-foreground mb-6">About {company?.name}</h2>
      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-3">Company Overview</h3>
          <p className="text-muted-foreground leading-relaxed whitespace-pre-line">
            {company?.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-6 border-t border-border">
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
              <Icon name="Target" size={20} className="text-primary" />
              Our Mission
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              {company?.mission}
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
              <Icon name="Eye" size={20} className="text-primary" />
              Our Vision
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              {company?.vision}
            </p>
          </div>
        </div>

        <div className="pt-6 border-t border-border">
          <h3 className="text-lg font-semibold text-foreground mb-4">Core Values</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {company?.values?.map((value, index) => (
              <div key={index} className="flex items-start gap-3 p-4 bg-muted rounded-lg">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name={value?.icon} size={20} className="text-primary" />
                </div>
                <div>
                  <h4 className="font-semibold text-foreground mb-1">{value?.title}</h4>
                  <p className="text-sm text-muted-foreground">{value?.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-6 border-t border-border">
          <h3 className="text-lg font-semibold text-foreground mb-4">Key Achievements</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {company?.achievements?.map((achievement, index) => (
              <div key={index} className="flex items-start gap-3 p-4 bg-success/5 border border-success/20 rounded-lg">
                <Icon name="Award" size={20} className="text-success flex-shrink-0 mt-1" />
                <div>
                  <p className="text-foreground font-medium">{achievement?.title}</p>
                  <p className="text-sm text-muted-foreground mt-1">{achievement?.year}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyOverview;